import "../../css/components/Cells.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import inView from "InView";
import Logger from "../utils/Logger";
import Cell from "./Cell";
import { getAnalyticsByAttr } from "../utils/analytics";
import api from "../utils/api";
import g from "../utils/globals";
import { getRatio } from "../utils/helpers";
import Dynamic from "./Dynamic";

const logger = new Logger(__filename);

class Cells extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
    };
    this.analytics = [];
    this.sendedAnalytics = [];
    this.loading = true;
  }

  componentDidMount = () => {
    if (this.props.enhancement && this.props.enhancement.init) {
      logger.log(`... enhancing content [${this.props.attrs.id}]`);
      this.props.enhancement.init(this);
    }
    this.handleInView();
    const element = document.querySelector("#home-content");
    element.addEventListener("touchmove", this.handleScroll, false);
    if (navigator.platform === "iPhone") {
      element.addEventListener("touchstart", this.handleScroll, false);
      element.addEventListener("touchend", this.handleScroll, false);
      element.addEventListener("scroll", this.handleScroll, false);
    }
  };

  componentWillUnmount = () => {
    const element = document.querySelector("#home-content");
    element.removeEventListener("touchmove", this.handleScroll, false);
    if (navigator.platform === "iPhone") {
      element.removeEventListener("touchstart", this.handleScroll, false);
      element.removeEventListener("touchend", this.handleScroll, false);
      element.removeEventListener("scroll", this.handleScroll, false);
    }
  };

  handleScroll = () => {
    inView(".cell-wrapper").check();
  };

  handleInView = () => {
    // used to send impressions
    inView.threshold(0.5);
    // because clones of swiper
    inView(".cell-wrapper")
      .on("enter", cell => {
        const index = parseInt(cell.getAttribute("data-index"), 10);
        if (!this.sendedAnalytics[index] && (!this.loading || !this.props.previousContent)) {
          cell.classList.add("itemInViewport");

          this.sendedAnalytics[index] = true;
          const analyticPerView = Object.assign({}, this.analytics[index], {
            action: "Banner_impression",
          });
          if (analyticPerView.origin) delete analyticPerView.origin;
          api.trackEvent(analyticPerView);
        }
        this.loading = false;
      })
      .on("exit", cell => {
        cell.classList.remove("itemInViewport");
      });
    inView(".cell-wrapper").check();
  };

  render = () =>
    this.props.contents.map((cell, k) => {
      if (!cell) return null;

      if (cell.module !== "Cell") {
        return <Dynamic key={k} {...cell} />;
      }
      const content = cell.contents.find(x => (x && x.module ? x.module !== "Text" : null));
      if (!content) return null;
      const text = cell.contents.find(x => (x && x.module ? x.module === "Text" : null));
      cell.style = {
        color: text && text.styles && text.styles.color ? text.styles.color : "#000000",
      };
      // TODO: this shoud be improved
      if (g.editMode && document.querySelector(`#frm-renderer-${k} #color`)) {
        const newColor = document.querySelector(`#frm-renderer-${k} #color`).value;
        cell.style.color = newColor.length > 6 ? newColor : cell.style.color;
      }

      const ratio = content.ratio;

      if (ratio) {
        cell.style.paddingBottom = `${getRatio(ratio)}%`;
      }

      const dataAttrs = cell.dataAttrs;
      const analytics = getAnalyticsByAttr(content, dataAttrs, k);
      this.analytics.push(analytics);
      return <Cell key={k} {...cell} analytics={analytics} />;
    });
}

Cells.propTypes = {
  attrs: PropTypes.object,
  contents: PropTypes.array,
};

export default Cells;
